import { render, staticRenderFns } from "./PromotionsOverview.vue?vue&type=template&id=2c69bd5a&"
import script from "./PromotionsOverview.vue?vue&type=script&lang=js&"
export * from "./PromotionsOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports